import {
  appSync,
  startListening,
  selectAuthenticationStatus,
  initiateLogin,
  appAuthenticated,
} from '@betty/toolkit/state';
import {
  fetchGames,
  launchGame,
  selectGames,
  selectGamesState,
} from './games.slice';
import { selectAccount } from '@betty/account';
import { getKey } from '@betty/i18n';
import { getLockedLabel } from '../../components/Games/Game/Game.utils';
import { BottomSheet, navigationRef } from '@betty/navigation';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchGames('authenticated'));
  },
});

startListening({
  actionCreator: launchGame,
  effect: async (action, { dispatch, getState, condition }) => {
    const { id, currencyCode } = action.payload;
    const gamesDataState = selectGamesState(getState());
    const authStatus = selectAuthenticationStatus(getState());

    if (authStatus === 'unauthenticated') {
      dispatch(initiateLogin());

      await condition(appAuthenticated.match);
      await condition(fetchGames.fulfilled.match);
    }

    if (gamesDataState === 'idle' || gamesDataState === 'pending') {
      await condition(fetchGames.fulfilled.match);
    }

    const state = getState();
    const { status, statusReason } = selectAccount(state) || {};
    const games = selectGames(state);
    const game = games[id];
    const releaseDate = game && game.displayFeatures.ComingSoon?.validUntil;

    try {
      if (!game) {
        throw new Error(getKey('gameNotFound', { ns: 'games' }));
      }

      if (status === 'Timeout') {
        throw new Error(getKey('userOnBreak', { ns: 'games' }));
      }

      if (status === 'Suspended') {
        throw new Error(getKey('userSuspendedGame', { ns: 'games' }));
      }

      if (
        status === 'Pending' &&
        (statusReason === 'KYC incomplete' ||
          statusReason === 'KYC in progress')
      ) {
        throw new Error(getKey('userPendingGame', { ns: 'games' }));
      }

      if (releaseDate) {
        throw new Error(
          getKey('gameNotReleased', {
            ns: 'games',
            date: getLockedLabel(releaseDate),
          }),
        );
      }

      navigationRef.navigate('GameplayScreen', { id, currencyCode });
    } catch (error) {
      if (error instanceof Error) {
        BottomSheet.open({
          namespace: 'common',
          type: 'InfoImage',
          data: {
            image: 'common.rejected',
            titleNS: 'common',
            titleKey: 'errorTitle',
            description: error.message,
          },
        });
      }
    }
  },
});
